<template>
  <div class="mx-auto my-5">
    <b-modal ref="modalUnconfirmed" title="Attention:" @cancel="resendEmail">
      <div class="d-block text-center">
        <p>User account has not been activated. Please check your inbox for confirmation email</p>
      </div>
      <div slot="modal-cancel">
        Resend confirmation email
      </div>
    </b-modal>
    <div class="account-wall mb-3">
	    <h1 class="text-center login-title">Login with escience passport </h1>
      <iframe id="Frame1" frameborder="no" border="0" scrolling="no" allowtransparency="yes" style="width:100%;height:340px;margin-top:50px" src="https://passport.escience.cn/oauth2/authorize?response_type=code&redirect_uri=http://materiae.iphy.ac.cn/callback&client_id=48543&theme=embed" > </iframe>
	    <a href="/Login" class="text-center new-account">Back to log in </a>
	    <a href="/register" class="text-center new-account">Create an account </a>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
